import { memo } from "react";
import { Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { View } from "../../View";
import { palette } from "../../../theme/palette";
import { POSTCODE } from "../../../consts/strings";

const useStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row-reverse",
    padding: "16px",
    marginTop: "10px",
  },
  yellow: {
    background: palette.btn.yellowFill,
    color: palette.typography.black.high,
    border: palette.btn.yelloBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.yellowFill,
    },
  },
  blue: {
    background: palette.btn.blueFill,
    color: palette.typography.white.high,
    border: palette.btn.blueBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.blueFill,
    },
  },
});

export const RemoveArtificialPostcodeActions = memo(
  ({ level, hasLocation, onCancel, onContinue }) => {
    const styles = useStyles();

    if (level === POSTCODE || hasLocation)
      return (
        <View className={styles.container}>
          <Button
            className={styles.blue}
            variant={"contained"}
            onClick={onContinue}
          >
            Remove
          </Button>
          <Button
            className={styles.yellow}
            variant={"contained"}
            onClick={onCancel}
          >
            Cancel
          </Button>
        </View>
      );
    else
      return (
        <View className={styles.container}>
          <Button
            className={styles.yellow}
            variant={"contained"}
            onClick={onCancel}
          >
            Continue
          </Button>
        </View>
      );
  }
);
